import colors from './colors.json'
// FIXME: Add correct theme colors
import Fonts from './fonts'
const theme = { colors, Fonts }

export default theme
